import { IMPORT_HISTORY_DOWNLOAD_TYPE } from 'api/import_history/constants'

export const CATEGORIES = [
  {
    key: 0,
    value: IMPORT_HISTORY_DOWNLOAD_TYPE.SHIFT_IMPORT,
    label: 'シフトインポート',
  },
  // TODO
  // 現状メンバーインポートについては未対応のため、フィルターメニューのメンバーインポートの項目はコメントアウトで非表示にしておく
  /*
  {
    key: 1,
    value: IMPORT_HISTORY_DOWNLOAD_TYPE.WORKER_IMPORT,
    label: 'メンバーインポート',
  },
  */
]
